import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Select from '../../SelectCustom';

import { PROFILE } from '../../../constants/strings';

import { enhance } from './enhance';

class LanguagePicker extends PureComponent {
  onLocaleChange = val => {
    const { isLoggedUser, onChange, setLanguage } = this.props;
    const lang = val.value;

    onChange(lang);
    if (isLoggedUser) setLanguage(lang);
  };

  render() {
    const { locale } = this.props;
    const langs = [
      { value: 'en', label: 'English' },
      { value: 'es', label: 'Español' },
      { value: 'zh', label: '中文' },
    ];

    return (
      <section styleName="language-settings">
        <h3 styleName="sectionTitle">
          <FormattedMessage {...PROFILE.languageSettings.title} />
        </h3>
        <div styleName="fieldsetContent fieldsetContent--withColumns">
          <div styleName="fieldWrapper">
            <div styleName="field">
              <Select
                name="language"
                options={langs}
                placeholder="Pick a language"
                value={locale}
                onChange={this.onLocaleChange}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

LanguagePicker.propTypes = {
  locale: PropTypes.string,
  setLanguage: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  onChange: PropTypes.func,
  isLoggedUser: PropTypes.bool,
};

export default enhance(LanguagePicker);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/LanguagePicker/index.jsx